import { Role } from 'model/IChat';
import { useEffect, useState } from 'react';
import { useAccount, useUser } from '~/authentication/store';

function useAccountRoles() {
  const { account, realAccount } = useAccount();
  const { user, isHost, isAdmin, isLoggedIn } = useUser();
  const [roles, setRoles] = useState<Role[]>([]);
  useEffect(() => {
    const newRoles = [...(user?.roles || [])];
    if (!isLoggedIn) {
      newRoles.push('unlogged');
    } else {
      if (isHost) {
        newRoles.push('host');
      } else {
        newRoles.push('guest');
      }
      if (isAdmin) {
        newRoles.push('admin');
      }
      if (realAccount && account?.id !== realAccount?.id) {
        newRoles.push('impersonator');
      }
      newRoles.push('loggedin');
    }
    setRoles(newRoles);
  }, [isLoggedIn, isHost, isAdmin, user, account, realAccount]);

  return roles;
}

export default useAccountRoles;
